import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Link } from 'react-router-dom'
import Button from 'react-bootstrap/Button'

import bg from '../../assets/img/bg.jpg'
import { ReactComponent as Dryer } from '../../assets/svg/Hairstyle.svg'
import { ReactComponent as Brush } from '../../assets/svg/hair-washing-sink-svgrepo-com.svg'
import { ReactComponent as Scrub } from '../../assets/svg/scrub-disc-svgrepo-com.svg'
import { ReactComponent as Comb } from '../../assets/svg/comb-svgrepo-com.svg'

import SEO from '../../components/SEO'
import './Services.css'

const servicesList = [
  {
    id: 'box-braids',
    title: 'Box Braids',
    description: 'At Sarah Adam Braiding Salon, we specialize in Box Braids, a timeless and versatile style that not only enhances your natural beauty but also protects your hair. Our skilled braiders ensure that each braid is crafted with precision and care, giving you a long-lasting and stylish look.',
    Icon: Brush,
  },
  {
    id: 'cornrows',
    title: 'Cornrows',
    description: 'At Sarah Adam Braiding Salon, we take pride in offering professional Cornrows services, a classic and deeply rooted African braiding style. Our experienced braiders are skilled in creating neat, intricate, and stylish cornrows that can be worn for both casual and formal occasions. Whether you\'re looking for a simple, traditional style or something more creative and detailed, we\'re here to bring your vision to life.',
    Icon: Dryer,
  },
  {
    id: 'senegalese-twists',
    title: 'Senegalese Twists',
    description: 'At Sarah Adam Braiding Salon, we take pride in offering professional Senegalese Twists services, a classic and deeply rooted African braiding style. Our experienced braiders are skilled in creating neat, intricate, and stylish twists that can be worn for both casual and formal occasions. Whether you\'re looking for a simple, traditional style or something more creative and detailed, we\'re here to bring your vision to life.',
    Icon: Scrub,
  },
  {
    id: 'micro-braid',
    title: 'Micro Braids',
    description: 'At Sarah Adam Braiding Salon, our Micro Braids services offer an intricate and elegant style, perfect for clients who desire a detailed, long-lasting look. Micro braids are ideal for both casual and formal occasions, providing versatility and sophistication with every strand.',
    Icon: Scrub,
  },
  {
    id: 'tree-braids',
    title: 'Tree Braids',
    description: 'At Sarah Adam Braiding Salon, we offer professional Tree Braids services for those looking to achieve a beautiful, natural-looking hairstyle with the convenience of a protective style. Tree braids provide the illusion of free-flowing hair while incorporating the benefits of a braid, making them a versatile and stylish option.',
    Icon: Comb,
  },
  {
    id: 'havana-twists',
    title: 'Havana Twists',
    description: 'At Sarah Adam Braiding Salon, we offer Havana Twists, a gorgeous, voluminous protective style that combines elegance with ease. Our expert stylists specialize in creating lightweight, soft, and natural-looking twists that can be styled in various ways, giving you both versatility and protection.',
    Icon: Comb,
  },
]

const Services = () => {
  const heroStyle = {
    backgroundImage: `url(${bg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  }

  return (
    <div className="services-page">
      <SEO title="Our Services" description="Braiding, twists, cornrows and more at Sarah Adom Braiding Salon." />
      <section className="services-hero" style={heroStyle}>
        <div className="services-hero-inner">
          <span className="services-hero-badge">What we offer</span>
          <h1 className="services-hero-title">Our Services</h1>
          <p className="services-hero-desc">Professional braiding, twists, and styling — see what we offer below.</p>
          <Button as={Link} to="/appointment" className="services-hero-cta btn-rita">
            Book an appointment
          </Button>
        </div>
      </section>

      <Container className="services-content">
        {servicesList.map((service) => {
          const { Icon } = service
          return (
            <article key={service.id} className="service-block">
              <Row className="service-row align-items-center">
                <Col xs={12} md={5} className="service-icon-col">
                  <div className="service-icon-wrap">
                    <Icon />
                  </div>
                </Col>
                <Col xs={12} md={7} className="service-text-col">
                  <h2 className="service-title">{service.title}</h2>
                  <p className="service-desc">{service.description}</p>
                </Col>
              </Row>
            </article>
          )
        })}
      </Container>

      <div className="services-cta-bottom">
        <Container>
          <p className="services-cta-text">Ready to book? We’d love to see you.</p>
          <Button as={Link} to="/appointment" className="btn-rita">
            Book an appointment
          </Button>
        </Container>
      </div>
    </div>
  )
}

export default Services
